var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "button",
      {
        staticClass:
          "date-navigation__button gds-button gds-compact gds-button-outline",
        attrs: { disabled: _vm.disabled, title: "Calendar" },
        on: {
          click: function($event) {
            !_vm.disabled && _vm.jumpToDate()
          }
        }
      },
      [
        _c("svg", { staticClass: "gds-icon" }, [
          _c("use", {
            attrs: {
              "xlink:href":
                "/wp-content/themes/gmptwentynineteen/assets/symbol-defs.svg#gds-icon-calendar"
            }
          })
        ]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.buttonLabel || _vm.defaultButtonLabel))])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }